import { c as _c } from "react/compiler-runtime";
import { Checkbox, Form, SearchInput } from '@onefootprint/ui';
import { useState } from 'react';
import { useFormContext } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import FiltersDrawer from '@/components/filters-drawer';
import { isForbiddenError } from '@/components/forbidden';
import usePlaybookOptions from '@/hooks/use-deprecated-playbook-options';
import type { FormData } from '../../drawer-filter.type';
import ErrorComponent from './components/error';
import Loading from './components/loading';
const LOADING_ROWS = 5;
type PlaybookMeta = {
  label: string;
  value: string;
  key: string;
};
const Playbooks = () => {
  const $ = _c(68);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = {
      keyPrefix: "pages.entities.filters.drawer"
    };
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  const {
    t
  } = useTranslation("common", t0);
  const methods = useFormContext();
  const {
    getValues,
    watch
  } = methods;
  let t1;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = {};
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const {
    data,
    isPending: playbooksLoading,
    isError: playbooksError,
    error
  } = usePlaybookOptions(t1);
  const [searchTerm, setSearchTerm] = useState("");
  let t2;
  if ($[2] !== getValues) {
    t2 = new Set(Object.entries(getValues("playbooks")).filter(_temp).map(_temp2));
    $[2] = getValues;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  const selectedPlaybooks = t2;
  let T0;
  let filteredAndSortedPlaybooks;
  let t3;
  let t4;
  let t5;
  let t6;
  let t7;
  let t8;
  let versionedPlaybook;
  if ($[4] !== data || $[5] !== error || $[6] !== methods || $[7] !== playbooksLoading || $[8] !== searchTerm || $[9] !== selectedPlaybooks || $[10] !== t || $[11] !== watch) {
    t8 = Symbol.for("react.early_return_sentinel");
    bb0: {
      let t9;
      if ($[21] !== searchTerm) {
        t9 = playbook => {
          const search = searchTerm.toLowerCase();
          return playbook.label.toLowerCase().includes(search) || playbook.key.toLowerCase().includes(search);
        };
        $[21] = searchTerm;
        $[22] = t9;
      } else {
        t9 = $[22];
      }
      const filtered = (data ?? []).filter(t9);
      let t10;
      if ($[23] !== selectedPlaybooks) {
        t10 = (a, b) => {
          if (selectedPlaybooks.has(a.value)) {
            return -1;
          }
          if (selectedPlaybooks.has(b.value)) {
            return 1;
          }
          return 0;
        };
        $[23] = selectedPlaybooks;
        $[24] = t10;
      } else {
        t10 = $[24];
      }
      filteredAndSortedPlaybooks = filtered.sort(t10);
      let t11;
      if ($[25] !== methods) {
        t11 = () => {
          methods.setValue("playbookVersions", {});
        };
        $[25] = methods;
        $[26] = t11;
      } else {
        t11 = $[26];
      }
      const handleSelectPlaybook = t11;
      let t12;
      if ($[27] !== methods) {
        t12 = (versionKey, checked) => {
          methods.setValue("playbooks", {});
          methods.setValue("playbookVersions", {
            [versionKey]: checked
          });
        };
        $[27] = methods;
        $[28] = t12;
      } else {
        t12 = $[28];
      }
      const handleSelectVersionedPlaybook = t12;
      let t13;
      if ($[29] !== data) {
        t13 = value_0 => {
          const [key_0, version] = value_0.split(":v");
          const playbook_1 = data?.find(playbook_0 => playbook_0.key === key_0);
          if (!playbook_1 || !version || Number.isNaN(Number(version))) {
            return;
          }
          return {
            playbook: playbook_1,
            version,
            versionKey: `${key_0}:v${version}`
          };
        };
        $[29] = data;
        $[30] = t13;
      } else {
        t13 = $[30];
      }
      const findVersionedPlaybook = t13;
      let selectedPlaybookVersions;
      let t14;
      if ($[31] !== findVersionedPlaybook || $[32] !== searchTerm || $[33] !== watch) {
        selectedPlaybookVersions = watch("playbookVersions");
        const [selectedVersionedPlaybookKey] = Object.entries(selectedPlaybookVersions).find(_temp3) ?? [];
        t14 = searchTerm ? findVersionedPlaybook(searchTerm) : findVersionedPlaybook(selectedVersionedPlaybookKey ?? "");
        $[31] = findVersionedPlaybook;
        $[32] = searchTerm;
        $[33] = watch;
        $[34] = selectedPlaybookVersions;
        $[35] = t14;
      } else {
        selectedPlaybookVersions = $[34];
        t14 = $[35];
      }
      versionedPlaybook = t14;
      if (isForbiddenError(error)) {
        t8 = null;
        break bb0;
      }
      t6 = "flex flex-col gap-3";
      let t15;
      if ($[36] !== t) {
        t15 = t(_temp4);
        $[36] = t;
        $[37] = t15;
      } else {
        t15 = $[37];
      }
      let t16;
      if ($[38] === Symbol.for("react.memo_cache_sentinel")) {
        t16 = e => setSearchTerm(e.target.value);
        $[38] = t16;
      } else {
        t16 = $[38];
      }
      if ($[39] !== searchTerm || $[40] !== t15) {
        t7 = <SearchInput placeholder={t15} size="compact" value={searchTerm} onChange={t16} />;
        $[39] = searchTerm;
        $[40] = t15;
        $[41] = t7;
      } else {
        t7 = $[41];
      }
      T0 = FiltersDrawer.List;
      if ($[42] !== playbooksLoading) {
        t3 = playbooksLoading && <Loading count={LOADING_ROWS} />;
        $[42] = playbooksLoading;
        $[43] = t3;
      } else {
        t3 = $[43];
      }
      if ($[44] !== handleSelectVersionedPlaybook || $[45] !== selectedPlaybookVersions || $[46] !== versionedPlaybook) {
        t4 = versionedPlaybook && <Checkbox key={versionedPlaybook.versionKey} label={`${versionedPlaybook.playbook.label} (version ${versionedPlaybook.version})`} name={`playbookVersions.${versionedPlaybook.versionKey}`} checked={selectedPlaybookVersions[versionedPlaybook.versionKey] ?? false} onChange={value_1 => handleSelectVersionedPlaybook(versionedPlaybook.versionKey, value_1.target.checked)} hint={<span className="text-tertiary cursor-default text-snippet-1">{versionedPlaybook.versionKey}</span>} />;
        $[44] = handleSelectVersionedPlaybook;
        $[45] = selectedPlaybookVersions;
        $[46] = versionedPlaybook;
        $[47] = t4;
      } else {
        t4 = $[47];
      }
      let t17;
      if ($[48] !== handleSelectPlaybook) {
        t17 = playbook_2 => <Form.Checkbox key={playbook_2.value} label={playbook_2.label} name={`playbooks.${playbook_2.value}`} onChange={handleSelectPlaybook} hint={<span className="text-tertiary cursor-default text-snippet-1">{playbook_2.key}</span>} />;
        $[48] = handleSelectPlaybook;
        $[49] = t17;
      } else {
        t17 = $[49];
      }
      t5 = filteredAndSortedPlaybooks.map(t17);
    }
    $[4] = data;
    $[5] = error;
    $[6] = methods;
    $[7] = playbooksLoading;
    $[8] = searchTerm;
    $[9] = selectedPlaybooks;
    $[10] = t;
    $[11] = watch;
    $[12] = T0;
    $[13] = filteredAndSortedPlaybooks;
    $[14] = t3;
    $[15] = t4;
    $[16] = t5;
    $[17] = t6;
    $[18] = t7;
    $[19] = t8;
    $[20] = versionedPlaybook;
  } else {
    T0 = $[12];
    filteredAndSortedPlaybooks = $[13];
    t3 = $[14];
    t4 = $[15];
    t5 = $[16];
    t6 = $[17];
    t7 = $[18];
    t8 = $[19];
    versionedPlaybook = $[20];
  }
  if (t8 !== Symbol.for("react.early_return_sentinel")) {
    return t8;
  }
  let t9;
  if ($[50] !== filteredAndSortedPlaybooks || $[51] !== playbooksLoading || $[52] !== t || $[53] !== versionedPlaybook) {
    t9 = !playbooksLoading && filteredAndSortedPlaybooks.length === 0 && !versionedPlaybook && <p className="text-tertiary text-caption-1">{t(_temp5)}</p>;
    $[50] = filteredAndSortedPlaybooks;
    $[51] = playbooksLoading;
    $[52] = t;
    $[53] = versionedPlaybook;
    $[54] = t9;
  } else {
    t9 = $[54];
  }
  let t10;
  if ($[55] !== T0 || $[56] !== t3 || $[57] !== t4 || $[58] !== t5 || $[59] !== t9) {
    t10 = <T0>{t3}{t4}{t5}{t9}</T0>;
    $[55] = T0;
    $[56] = t3;
    $[57] = t4;
    $[58] = t5;
    $[59] = t9;
    $[60] = t10;
  } else {
    t10 = $[60];
  }
  let t11;
  if ($[61] !== playbooksError) {
    t11 = playbooksError && <ErrorComponent />;
    $[61] = playbooksError;
    $[62] = t11;
  } else {
    t11 = $[62];
  }
  let t12;
  if ($[63] !== t10 || $[64] !== t11 || $[65] !== t6 || $[66] !== t7) {
    t12 = <div className={t6}>{t7}{t10}{t11}</div>;
    $[63] = t10;
    $[64] = t11;
    $[65] = t6;
    $[66] = t7;
    $[67] = t12;
  } else {
    t12 = $[67];
  }
  return t12;
};
export default Playbooks;
function _temp(t0) {
  const [, value] = t0;
  return value;
}
function _temp2(t0) {
  const [key] = t0;
  return key;
}
function _temp3(t0) {
  const [, v] = t0;
  return v;
}
function _temp4($) {
  return $.playbooks.searchPlaceholder;
}
function _temp5($_0) {
  return $_0.playbooks.empty;
}